import React from 'react';
import {connect} from 'react-redux';
import {IndexLink, Link, withRouter} from 'react-router';
import {isMobile} from 'react-device-detect';

import * as commonApi from '../../api/common-api';
import * as userApi from '../../api/user-api';

import Loading from 'react-loading';
import axios from 'axios';
import ProfileInfo from '../commons/profile/profile_info';
import ProfileAbout from '../commons/profile/profile_about';
import ProfileAd from "../commons/profile/profile_ad";
import ProfileService from '../commons/profile/profile_service';
import ProfileReviews from '../commons/profile/profile_review';
import ReactGA from 'react-ga';
import ProfileBio from "../commons/profile/profile_bio";
import ProfileSkill from "../commons/profile/profile_skill";

class ProfileCoachPage extends React.Component {
    constructor(props) {
        super(props);

        // Add your tracking ID created from https://analytics.google.com/analytics/web/#home/
        ReactGA.initialize('UA-122650632-1');
        // This just needs to be called once since we have no routes in this case.
        ReactGA.pageview(window.location.pathname);

        let profileId = this.props.params.profileId;

        this.state = {
            profileId: profileId,
            showDD: false,
            emerging: 0,
            verified: false,
        };

        this.getProfile = this.getProfile.bind(this);
    }

    componentDidMount = () => {
        userApi.getMyProfile();
        this.getProfile();
    }

    componentWillReceiveProps = (nextProps) => {
        var load = false;
        if (this.state.profileId != nextProps.params.profileId) {
            load = true;
        }

        if (load) {
            this.setState({profileId: nextProps.params.profileId}, () => {
                this.getProfile();
            });
        } else {
            this.setState({profileId: nextProps.params.profileId});
        }
    }

    getProfile = () => {
        axios.get(commonApi.getAPIURL() + '?api=getUserProfile&user_id=' + this.state.profileId)
            .then(response => {
                if (response.data.status == 1) {
                    this.setState(Object.assign(this.state, {
                        user: response.data.data,
                    }));
                }
                return response;
            });
    }

    onInvite(event) {
        axios.get(commonApi.getAPIURL() + '?api=connectAccount&acc_id=' + this.state.user.id_account)
            .then(response => {
                if (response.data.status == 1) {
                    commonApi.showAlert("Your request has been sent!")
                    var msg = this.props.user[0].name_account + " " + this.props.user[0].last_name_account + " sent you a friend request";
                    var avatar = '/static/img/appimg/common-noavatar-sm.jpg';
                    if (this.props.user[0].image_avatar_account > 0) {
                        avatar = this.props.user[0].link_thumb_file;
                    }
                    var dataSend = {
                        from: this.props.user[0].id_account,
                        to: [this.state.user.id_account],
                        msg: msg,
                        icon: avatar
                    };
                    this.props.socket.emit('request', JSON.stringify(dataSend));
                    //console.log(response.data);
                    this.getProfile();
                }
                return response;
            });
    }

    onSendMessage(e) {
        axios.get(commonApi.getAPIURL() + '?api=getGroupByUser&id_account=' + this.state.user.id_account)
            .then(response => {
                if (response.data.status == 1) {
                    //commonApi.showAlert("Your request has been sent!")
                    //console.log(response.data);
                    //this.getConnections();
                    commonApi.openChatBox(response.data.data);
                }
                return response;
            });
    }

    toggleDD(e) {
        e.stopPropagation();
        var showDD = !this.state.showDD;
        this.setState({showDD: showDD});
    }

    onUnfriend(event) {
        axios.get(commonApi.getAPIURL() + '?api=removeConnect&acc_id=' + this.state.user.id_account)
            .then(response => {
                if (response.data.status == 1) {
                    //commonApi.showAlert("Your request has been sent!")
                    //console.log(response.data);
                    this.getProfile();
                }
                return response;
            });
    }

    handleFileUpload(event) {
        console.log("handleFileUpload");
        if (event.target.files.length > 0) {
            var fileUpload = event.target.files[0];
            if (fileUpload.size > file_limit) {
                commonApi.showAlert("Max file size is 25MB!");
                this.refs.file_input.value = '';
                return;
            }
            var Extension = fileUpload.name.substring(fileUpload.name.lastIndexOf('.') + 1).toLowerCase();
            var imageExt = ['jpg', 'jpeg', 'png', 'bmp', 'gif'];
            if (imageExt.indexOf(Extension) != -1) {

                var data = new FormData();
                data.append('file', fileUpload);
                axios.post('/code/apis.php?api=updateAvatar', data)
                    .then(response => {
                        if (response.data.status == 1) {
                            this.getProfile();
                            //commonApi.showAlert("Your profile has been updated!");
                            //courseApi.getMyCourses();
                            //this.props.handleChange(2);
                            //store.dispatch(getUserSuccess(response.data.data));
                        } else {
                            commonApi.showAlert(response.data.message);
                        }
                        //console.log(response.data);

                        return response;
                    });

            } else {
                commonApi.showAlert("Please select image only");
                this.refs.file_input.value = '';
            }
        }

    }

    handleAttClick(event) {
        this.refs.file_input.value = '';
        this.refs.file_input.click();
    }

    handleVerified = () => {
        let verified = this.state.verified
        this.setState({verified: !verified})
    }
    render() {
        if (this.state.user == undefined || this.props.user[0] == undefined) {
            return (
                <div className="app_page_wrapper">
                    <div style={{color: "#545454"}}>
                        <Loading delay={0} type='spinningBubbles' color='rgba(84, 84, 84, 1)' width={20} height={20}/>
                    </div>
                </div>
            );
        }

        let isMySupper = this.props.user[0].supper_account == 1 || this.state.profileId == this.props.user[0].id_account
        let isMy = this.state.profileId == this.props.user[0].id_account

        var avatar = '/static/img/appimg/common-noavatar-sm.jpg';
        if (this.state.user.image_avatar_account > 0) {
            avatar = this.state.user.link_thumb_file;
        }
        var invite = "";
        var emerging = "";
        var verified = "";
        if (this.state.user.id_account != this.props.user[0].id_account && this.props.isPublic != true) {//not owner
            if (this.state.user.connect_cur_user == -1) {
                invite = (
                    <div className="common_header_btns">
                        <a onClick={this.onInvite.bind(this)} className="btn_v btn_confirm" style={{padding: '6px 15px', marginRight: '5px'}}>Connect</a>
                        <a onClick={this.onSendMessage.bind(this)} className="btn_v btn_cancel" style={{padding: '6px 15px'}}>Send a Message</a>
                    </div>
                );
            }
            else if (this.state.user.connect_cur_user == 1) {
                invite = (
                    <div className="common_header_btns message-block">
                        <a onClick={this.onSendMessage.bind(this)} className="btn_v btn_cancel" style={{padding: '6px 15px'}}>Send a Message</a>
                        <div className="profile_option">
                            <a onClick={this.toggleDD.bind(this)} className="trigger"><img src="/static/img/appimg/icon_down_black.png" alt=""/></a>
                            <div className={this.state.showDD ? "popupDrop" : "hide-el"}>
                                <ul>
                                    <li className="post_icon_edit"><a onClick={this.onUnfriend.bind(this)}>Remove connection</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                );
            } else {
                invite = (
                    <div className="common_header_btns message-block">
                        <a onClick={this.onSendMessage.bind(this)} className="btn_v btn_cancel" style={{padding: '6px 15px'}}>Send a Message</a>
                        <div className="profile_option">
                            <a onClick={this.toggleDD.bind(this)} className="trigger"><img src="/static/img/appimg/icon_down_black.png" alt=""/></a>
                            <div className={this.state.showDD ? "popupDrop" : "hide-el"}>
                                <ul>
                                    <li className="post_icon_edit"><a onClick={this.onUnfriend.bind(this)}>Remove connection</a></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                );
            }

            if (this.state.emerging) {
                emerging = (<img src="/static/img/appimg/emerging.png" alt=""/>)
            }
        }
        // else {
        //     invite = (
        //         <div className="common_header_btns message-block score-submit">
        //             <div className={"project-score"}>
        //                 <div className={"percent"}>{this.state.score}</div>
        //                 <div className={"line-percent"}></div>
        //                 <div className={"processing"}>Project Success</div>
        //             </div>
        //         </div>
        //     );
        //
        //     if (this.state.emerging) {
        //         invite = (
        //             <div className="common_header_btns message-block emerging-submit">
        //                 <div className={"project-emerging"}>
        //                     <img src="/static/img/appimg/emerging.png" alt=""/>
        //                 </div>
        //             </div>
        //         );
        //     }
        // }

        verified = (
            <div className="icon-vefified">
                <img src="/static/img/appimg/emerging-icon.png" alt=""/> Verified Coach
            </div>
        );

        let bg_outside_url = '/static/img/appimg/default-banner.png'

        return (
            <div className={this.props.isPublic? "isPublic" : ""} id="div-profile">
                <div id="coach-view-profile" className={isMobile?"app-page-wrapper-mobile":"app_page_wrapper"}>
                    <div id="root-linkedin" className="profile-update" style={{paddingTop: "10px"}}>
                        <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" className="hidden" data-elementtiming="true" alt="" role="none"/>
                        <section id="ember3348" className="artdeco-card ember-view pv-top-card">
                            <div className="live-video-hero-image" style={{minHeight: "195.5px", maxHeight: "195.5px"}}>
                                <div tabIndex="0" aria-label="Profile background"
                                     className="profile-background-image">
                                    <div className="profile-background-image__image-container">
                                        <img
                                            className="profile-background-image__image full-width full-height no-marging-top"
                                            id="profile-background-image-target-image"
                                            alt="Background Image"
                                            src={bg_outside_url}
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="ph5 pb5">
                                <div className="display-flex pv-top-card--reflow">
                                    <div className="pv-top-card--photo text-align-left">
                                        <div className="pv-top-card__photo-wrapper ml0">
                                            <div className="presence-entity presence-entity--size-9 pv-top-card__image">
                                                <a onClick={() => this.setState({show: true})}>
                                                    <img className="img_circle_p" src={avatar} alt=""/></a>
                                                {this.props.user[0].id_account == this.state.user.id_account ? (
                                                        <div className="upload_wrapper_profile">
                                                            <a onClick={this.handleAttClick.bind(this)}>
                                                                <img className="upload_img" src="/static/img/appimg/icon_upload_avatar.png"
                                                                     alt=""/>
                                                            </a>
                                                            <input type="file" className="hide-el" ref="file_input"
                                                                   onChange={this.handleFileUpload.bind(this)}/>
                                                        </div>)
                                                    : ""
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="pt3">
                                    <div className="org-top-card__primary-content org-top-card-primary-content--zero-height-logo org-top-card__primary-content--ia">
                                        <div className="block mt2">
                                            <div className="common_title02 pb5">
                                                <div>
                                                    <h1 className="org-top-card-summary__title t-24 t-black t-bold truncate">
                                                        <span dir="ltr" className="display-flex">
                                                            {this.state.user.name_account + " " + this.state.user.last_name_account}
                                                            <div className="verified">
                                                                <span onMouseOver={this.handleVerified.bind(this)} onMouseOut={this.handleVerified.bind(this)} className="up-badge up-badge-tagline line-height-0 up-badge-verified up-popper-trigger" tabIndex="0" role="button" aria-describedby="popper_1">
                                                                    <div className="up-icon">
                                                                        <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" viewBox="0 0 14 14" role="img">
                                                                            <path d="M13.72 7.03c.45-.56.34-1.39-.24-1.82l-.55-.41c-.34-.25-.53-.66-.51-1.08l.03-.68c.03-.72-.53-1.32-1.25-1.33h-.68c-.42 0-.81-.22-1.05-.57L9.11.57c-.39-.6-1.2-.75-1.79-.33l-.55.4c-.34.24-.79.3-1.18.15L4.95.55c-.67-.25-1.41.11-1.64.79l-.21.65c-.14.4-.46.71-.87.82l-.65.18C.89 3.19.5 3.92.71 4.6l.21.65c.13.41.04.85-.22 1.18l-.42.54c-.45.56-.34 1.39.24 1.81l.55.41c.34.25.53.66.51 1.08l-.03.68c-.03.72.54 1.32 1.25 1.33h.68c.42 0 .81.22 1.05.57l.37.57c.39.6 1.21.75 1.79.33l.55-.4c.34-.25.78-.31 1.18-.16l.64.24c.67.25 1.41-.1 1.64-.79l.21-.65c.13-.4.45-.71.86-.82l.65-.17c.69-.19 1.09-.92.87-1.61l-.21-.65c-.13-.4-.05-.85.22-1.18l.42-.53zM6.06 9.84L3.5 7.27l1.23-1.23 1.33 1.33 3.21-3.21L10.5 5.4 6.06 9.84z"></path>
                                                                        </svg>
                                                                    </div>
                                                                </span>
                                                                <span id="popper_1" className={this.state.verified ? "popper up-popover" : "hide-el"}>
                                                                    <div className="size-sm display-verified">
                                                                        <div className="popper-wrapper">
                                                                            <div className="popper-inner">
                                                                                <div className="popper-content">
                                                                                    <span>This coach’s identity has been verified.</span>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </span>
                                                            </div>
                                                        </span>
                                                    </h1>
                                                    <p className="org-top-card-summary__tagline t-16 t-black">Versity Coach</p>
                                                    <p>{emerging}</p>
                                                    {/*{verified}*/}
                                                </div>
                                            </div>
                                            {/*{invite}*/}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>

                    <div id="profile-page" className="md-page md-page-profile">
                        <div className="page_course_main_wrapper">
                            <div className="content" style={{marginTop: 0}}>
                                <ProfileAbout cuser={this.state.user}
                                              user={this.props.user[0]}
                                              profileId={this.state.profileId}
                                              my={isMySupper}/>
                                <ProfileReviews user={this.props.user[0]}
                                                  profileId={this.state.profileId}
                                                  my={isMySupper}/>
                            </div>
                        </div>
                    </div>
                    <div className="md-page-side md-page-profile">
                        <ProfileSkill user={this.props.user[0]}
                                      profileId={this.state.profileId}
                                      my={isMySupper}/>
                    </div>
                </div>
            </div>
        )
    }
}

ProfileCoachPage.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};
const mapStateToProps = function (store) {
    return {
        user: store.userState.user,
        socket: store.msgState.socket
    };
};

export default connect(mapStateToProps)(withRouter(ProfileCoachPage));


/** WEBPACK FOOTER **
 ** ./src/client/app/appcomponents/pages/profile-coach.js
 **/